import styled from "styled-components";

export const GridWrapper = styled.div.attrs({
    id: "printer-card-grid-wrapper",
})`
    width: 100%;
`;

export const CardGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
    gap: 32px;
    width: 100%;
    align-items: start;
`;
